var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showSteps)?_c('Card',[_c('div',{staticClass:"withhold-container"},[_c('el-steps',{staticStyle:{"margin":"20px 0"},attrs:{"active":_vm.currentStep,"align-center":"","finish-status":"success"}},_vm._l((_vm.steps),function(step,index){return _c('el-step',{key:index,attrs:{"title":step.title}})}),1)],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }